import { Box, Button, Layout, Text } from '@wix/design-system'
import { useContent, useNext, usePageLoading } from '@wix/funnel-builder-lizard'
import React, { FC, useEffect, useState } from 'react'

import { usePageLogger } from '../../../bi/mfi'
import { delay } from '../../../utils/delay'
import { WixMobileContentWrapper } from '../../reusable/WixMobileContentWrapper/WixMobileContentWrapper'
import { WixMobileFooter } from '../../reusable/WixMobileFooter/WixMobileFooter'
import { WixMobileHeader } from '../../reusable/WixMobileHeader/WixMobileHeader'
import { WixMobileHeading } from '../../reusable/WixMobileHeading/WixMobileHeading'
import { WixMobilePage } from '../../reusable/WixMobilePage/WixMobilePage'
import { Content } from './WixVibeMobileSplitFixed.content'
import s from './WixVibeMobileSplitFixed.scss'

export const WixVibeMobileSplitFixed: FC = () => {
  const [isShowButtons, setIsShowButtons] = useState(false)
  const { content } = useContent<Content>()
  const pageLogger = usePageLogger()
  const [isPageLoading] = usePageLoading()
  const next = useNext()

  const handleClick = (optionKey: string, isSkip?: boolean) => async () => {
    if (isPageLoading) {
      return
    }

    await pageLogger.generalAction({ action: optionKey })
    await pageLogger.answer({ answer: optionKey })
    next({ [content.question.questionKey]: { values: [optionKey], skipped: isSkip } })
  }

  useEffect(() => {
    void pageLogger.screenView()
  }, [pageLogger])

  useEffect(() => {
    const showSkipWithDelay = async () => {
      await delay(100)
      setIsShowButtons(true)
    }
    showSkipWithDelay()
  }, [])

  return (
    <WixMobilePage>
      <WixMobileHeader />
      <div className={s.container}>
        <WixMobileContentWrapper>
          <WixMobileHeading textAlign="left">{content.title}</WixMobileHeading>

          <Layout cols={1} gap="8px">
            {content.description && (
              <div style={{ paddingTop: '12px' }}>
                <Text weight="normal">{content.description}</Text>
              </div>
            )}

            <Box direction="vertical" gap="24px" marginTop="20px">
              {content.text1 && <p className={s.text}>{content.text1}</p>}
              {content.text2 && <p className={s.text}>{content.text2}</p>}
              {content.text3.content.title && (
                <div className={s.secondQuestion}>
                  <h2 className={s.subtitle}> {content.text3.content.title}</h2>
                  <p className={s.text}>{content.text3.content.description}</p>
                </div>
              )}
            </Box>
          </Layout>
        </WixMobileContentWrapper>

        {isShowButtons && (
          <WixMobileFooter>
            <div className={s.buttons}>
              {content.question.options.map(({ type, optionKey, label }) => {
                return (
                  <Button
                    key={optionKey}
                    skin="dark"
                    size="large"
                    priority={type === 'skip' ? 'secondary' : 'primary'}
                    fullWidth
                    onClick={handleClick(optionKey, type === 'skip')}
                  >
                    {label}
                  </Button>
                )
              })}
            </div>
          </WixMobileFooter>
        )}
      </div>
    </WixMobilePage>
  )
}
